/* eslint-disable no-console */
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    services: [],
    additionalCards: [
      {
        name: 'W2P_PRODUCT_DEFINATION_PRICE_CALCULATION',
        description: 'W2P_PRODUCT_DESCRIPTION_PRICE_CALCULATION',
        route: 'prisberaknare-for-utskick',
        icon: 'mailbox-letter-flower.svg'
      },
      {
        name: 'W2P_SERVICE_CARD_TITLE_SEND_OUT_ARRIVAL',
        description: 'W2P_SERVICE_CARD_DESCRIPTION_SEND_OUT_ARRIVAL',
        route: 'utdelningsdag',
        icon: 'send-out-arrival.svg'
      },
      {
        name: 'W2P_SERVICE_CARD_TITLE_LEARN_MORE',
        description: 'W2P_SERVICE_CARD_DESCRIPTION_LEARN_MORE',
        route: 'learn-more',
        icon: 'learn-more.svg'
      }
    ]
  },
  actions: {
    fetchServices({ commit, state, rootState }) {
      const reqData = {
        params: {
          market: 'SE',
          userType: rootState.userType
        },
        headers: {
          Authorization: rootState.accessToken // this will be used in calculating for wic product
        }
      }

      if (!state.services.length) {
        axios
          .get(
            process.env.VUE_APP_W2P_API_BASE_URL +
              '/clientAPI/products/serviceCards',
            reqData
          )
          .then(response => {
            const cards = response.data.concat(state.additionalCards)

            commit('GET_SERVICES', cards)
          })
          .catch(err => {})
      }
    }
  },
  mutations: {
    GET_SERVICES(state, services) {
      state.services = services
    }
  }
}
